import { BookingCancelResponse } from "../api/BookingCancelResponse";

export class BookingCancel {
	paid: number;
	cancellationFee: number;
	refund: number;

	constructor(resp: BookingCancelResponse) {
		this.paid = resp.paid;
		this.cancellationFee = resp.cancellationFee;
		this.refund = resp.refund;		
	}
}